import { NavigationAwareObject } from '../NavigationAwareObject';
import { NavigationBehaviour } from './NavigationBehaviour';

import { vec3 } from 'gl-matrix';
import { Scene } from '../../scene/Scene';

export class EntityWanderingBehaviour implements NavigationBehaviour {
  private navObject?: NavigationAwareObject;
  private isWalking: boolean;
  constructor(
    public scene: Scene,
    public activity: number,
    public distance: number,
  ) {
    this.isWalking = false;
  }

  attach(navObject: NavigationAwareObject) {
    this.navObject = navObject;

    navObject.movement.onComplete.subscribe((mv) => {
      this.isWalking = false;
    });

    navObject.movement.onStep.subscribe((step) => {
      this.isWalking = true;
    });

    this.scene.tickEventManager.registerTimeEvent(() => {
      if (!this.isWalking && this.activity > Math.random()) {
        this.walkRandom();
      }
    }, 1000);
  }

  private walkRandom() {
    let currentNode = this.navObject!.movement.currentNode!.node;

    let nodes = this.scene.navigation.database.getObjectsInRange(
      currentNode.getPosition(),
      this.distance,
    );

    // Restrict to nodes in the same region — keeps wandering local and
    // skips paths that the region-graph would reject anyway.
    nodes = nodes.filter((n) => n.regionId === currentNode.regionId);

    if (nodes.length === 0) return;

    let node = nodes[Math.floor(Math.random() * nodes.length)];

    let range = vec3.subtract(vec3.create(), node.max, node.min);
    for (let axis = 0; axis < 2; axis++) {
      range[axis] = Math.random() * range[axis];
    }

    let newPos = vec3.add(vec3.create(), node.min, range);

    this.navObject!.navigateToNode(node, newPos, {
      maxRadius: this.scene.navigation.pathFinder.aiRadius,
    });
  }

  detach(navObject: NavigationAwareObject) {}
}
